import {createSelector} from 'reselect';

import * as ReportSelectors from '../../state/reports/selectors';
import {ReportViewRef} from '../../state/reports/types';
import * as ViewSelectors from '../../state/views/selectors';
import {LoadableView} from '../../state/views/types';

export type ReportViewInfo = {
  loading: boolean;
  reportViewRef?: ReportViewRef; // This goes into the "reports" reducer and grabs the report's viewRef object
  view?: LoadableView; // This goes in to the "views" reducer and grabs the view spec
  reportCID?: string; // This comes from the view spec or the id from report's viewRef object
};

export function makeReportViewInfoSelector() {
  return createSelector(
    ReportSelectors.getReportsState,
    ViewSelectors.getViews,
    (reports, views) => {
      // We need to wait for both report and view load actions to finish loading into redux
      if (reports.loading || views.loading) {
        return {
          loading: true,
          reportViewRef: undefined,
          view: undefined,
          reportCID: undefined,
        };
      }

      const reportViewRefValues = Object.values(reports.viewRefs);
      if (reportViewRefValues.length < 1) {
        return {
          loading: false,
          reportViewRef: undefined,
          view: undefined,
          reportCID: undefined,
        };
      }

      const reportViewRef = reportViewRefValues[0];
      if (reportViewRef == null) {
        return {
          loading: false,
          reportViewRef: undefined,
          viewSpec: undefined,
          reportCID: undefined,
        };
      }

      const reportCID = reportViewRef.id;
      return {
        loading: false,
        reportViewRef,
        view: views.views[reportCID],
        reportCID,
      };
    }
  );
}
